<div class="popup-container">

<header>
    <label class="close_button" (click)="close()">x</label>
    <div class="header d-block roboto-medium">
        <label class="ms-3 mt-3 mb-3">{{heading}}</label>
    </div>
</header>


<div class="body" [style]="errormsg? 'margin: 1% 2% 0% 2%;':  'margin: 1% 2% 2% 2%;'">
    <div class="row">
        <div class="col-6">
            <div>
                <span class="content">
                    <select [(ngModel)]="logisticsPoint" [ngModelOptions]="{ standalone: true }" class="category cat_style" (change)="refreshData()">
                        <option *ngFor="let eachplantList of plantList" [value]="eachplantList.position">
                          {{ eachplantList.description }}
                        </option>
                      </select>
                    <!-- <input type="text" class="category cat_style"> -->
                </span>
                <label class="catlabel cat_head">PLANT/SC/CD :</label>

            </div>
        </div>
        <div class="col-6">
            <div>
                <span class="content">
                    <input type="text" class="category cat_style" [(ngModel)]="ydParkingCapacity">
                </span>
                <label class="catlabel cat_head">Yard Parking Capacity
                    :</label>

            </div>
        </div>



        <div class="col-6">
            <div>

                <span class="content">
                    <input type="text" class="category cat_style" [(ngModel)]="suppliersClosed">
                </span>
                <label class="catlabel cat_head">Suppliers Closed :
                </label>

            </div>
        </div>
        <div class="col-6">
            <div>


                <span class="content">
                    <input type="text" class="category cat_style" [(ngModel)]="parkingOccupied">
                </span>
                <label class="catlabel cat_head">Parking Spaces
                    Occupied : </label>
            </div>
        </div>
        <div class="col-6">
            <div>


                <span class="content">
                    <input type="text" class="category cat_style" [(ngModel)]="actualDroppedRoutes">
                </span>
                <label class="catlabel cat_head">Actual Dropped Routes
                    : </label>

            </div>
        </div>
        <div class="col-6">
            <div>
                <span class="content">
                    <input type="text" class="category cat_style" [(ngModel)]="cntgntTrailers">
                </span>
                <label class="catlabel cat_head">Total Contingent
                    Trailers :</label>

            </div>
        </div>
        <div class="col-6">
            <div>

                <span class="content">
                    <input type="text" class="category cat_style" [(ngModel)]="routesMissedUnload">
                </span>
                <label class="catlabel cat_head">Actual Routes Missed
                    Unload : </label>

            </div>
        </div>

        <div class="col-6">
            <div>

                <span class="content">
                    <input type="number" class="category cat_style" [(ngModel)]="cntgntTrailersInUse">
                </span>
                <label class="catlabel cat_head">Contingent Trailers In
                    Use :</label>

            </div>
        </div>
        <div class="col-6">
            <div>

                <span class="content">
                    <input type="number" min="0" class="category cat_style" [(ngModel)]="namcExpedites">
                </span>
                <label class="catlabel cat_head">NAMC Expedites
                    :</label>

            </div>
        </div>
        <div class="col-6">
            <div>

                <span class="content">
                    <input type="number" min="0" class="category cat_style" [(ngModel)]="misconnects">
                </span>
                <label class="catlabel cat_head">Misconnects
                    :</label>

            </div>
        </div>
        <div class="col-6">
            <span class="content">
                <input type="text" class="category cat_style" [(ngModel)]="absenteeism">
            </span>
            <label class="catlabel cat_head">Absenteeism : </label>
        </div>
        <div class="col-6">
            <span class="content">
                <textarea class="category cat_style" placeholder="Comments" [(ngModel)]="comments"></textarea>
            </span>
            <label class="catlabel cat_head">Comments : </label>
        </div>
    </div>
</div>

<!-- <label class="catlabel cat_comnt">Comments :</label>
<textarea class="category" placeholder="Comments" [(ngModel)]="comments"></textarea> -->




<label *ngIf="errormsg" class="errormsg"> {{errormsg}} </label>
<div class="footer d-flex justify-content-end align-items-center fixed-bottom mt-2 pt-2 pb-2">
    <button class="cancel me-3 roboto-bold" (click)="close()"> CANCEL </button>
    <button class="submit black-button me-3 roboto-bold" (click)="saveClick()">UPDATE</button>
</div>
</div>